import React from "react";
import Section from "../components/Section";
import { Card, Tooltip, Typography } from "../components";

const TooltipSection = () => {
	const [tooltipPositon, setTooltipPosition] = React.useState<"top-left" | "top-right" | "top-center" | "bottom" | "left" | "right">("top-left");
	return (
		<Section title={"# Tooltip"}>
			<div className="d-flex align-items-center justify-content-between px-5 mx-5 gap2">
				<Tooltip label="This is Tooltip." width={"max-content"} position={tooltipPositon}></Tooltip>
				<Tooltip
					label="This is Tooltip."
					width={"max-content"}
					position={tooltipPositon}
					maxWidth="300px"
					supportingText="Tooltips are used to describe or identify an element. In most scenarios, tooltips help the user understand meaning, function or alt-text."
				>
					<Card className="p-2" size={"md"}>
						Hover Me
					</Card>
				</Tooltip>
			</div>
			<div className="d-flex align-items-center justify-content-start gap2">
				<div className="d-flex flex-direction-column">
					<Typography size="md" fontFamily="semibold">
						Tooltip Position
					</Typography>

					<div className="">
						<input
							checked={tooltipPositon === "left"}
							type="radio"
							name="left"
							id="left"
							onClick={(e: any) => setTooltipPosition(e.target.name)}
						/>
						<label className="pl-2 pointer" htmlFor="left">
							left
						</label>
					</div>
					<div className="">
						<input
							checked={tooltipPositon === "right"}
							type="radio"
							name="right"
							id="right"
							onClick={(e: any) => setTooltipPosition(e.target.name)}
						/>
						<label className="pl-2 pointer" htmlFor="right">
							right
						</label>
					</div>
					<div className="">
						<input
							checked={tooltipPositon === "bottom"}
							type="radio"
							name="bottom"
							id="bottom"
							onClick={(e: any) => setTooltipPosition(e.target.name)}
						/>
						<label className="pl-2 pointer" htmlFor="bottom">
							bottom
						</label>
					</div>
					<div className="">
						<input
							checked={tooltipPositon === "top-left"}
							type="radio"
							name="top-left"
							id="top-left"
							onClick={(e: any) => setTooltipPosition(e.target.name)}
						/>
						<label className="pl-2 pointer" htmlFor="top-left">
							top-left
						</label>
					</div>
					<div className="">
						<input
							checked={tooltipPositon === "top-right"}
							type="radio"
							name="top-right"
							id="top-right"
							onClick={(e: any) => setTooltipPosition(e.target.name)}
						/>
						<label className="pl-2 pointer" htmlFor="top-right">
							top-right
						</label>
					</div>
					<div className="">
						<input
							checked={tooltipPositon === "top-center"}
							type="radio"
							name="top-center"
							id="top-center"
							onClick={(e: any) => setTooltipPosition(e.target.name)}
						/>
						<label className="pl-2 pointer" htmlFor="top-center">
							top-center
						</label>
					</div>
				</div>
			</div>
		</Section>
	);
};

export default TooltipSection;
